import $ from 'jquery';
import Framework from 'framework';

$(() => {
	var $header = $('.header-mylt');
	var $anchor = $('#state-anchor');

	if(Framework.global.lt.pageProperties.experienceType === 'member') {
		$($anchor).on('change', () => {
			var headerVerticalSize = $header.outerHeight(true);
			var targetPosition = $($anchor.val()).offset().top - headerVerticalSize;
			$('html,body').animate({ scrollTop: targetPosition}, 'slow');
		});
	}
});
